// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2CN8W","item":"PaymentsMobile_item__3_1nj","label":"PaymentsMobile_label__3SeWO","amount":"PaymentsMobile_amount__36Ali"};